const PetitionError = require('../../petitionError');
const { getAnonymous, postAnonymous, post } = require('../../httpRequester');

class GetCommandDeviceException extends PetitionError {
  constructor(code) {
    super('Get commands device', code);
  }
}

class SentCommandDeviceException extends PetitionError {
  constructor(code) {
    super('Save commands device', code);
  }
}

async function getCommandsDevice(token) {
  try {
    const response = await getAnonymous(`commands/devices?token=${token}`);

    if (response.result === GetCommandDeviceException.success) {
      return response.commands;
    }
  } catch (error) {
    console.error(error);
  }
}

async function sentCommandDevice(token, payload) {
  try {
    const response = await post('commands/devices', payload, token);

    if (response.result === SentCommandDeviceException.success) {
      return response;
    }
  } catch (error) {
    console.error(error);
    throw error;
  }
}

module.exports = { getCommandsDevice, GetCommandDeviceException, sentCommandDevice, SentCommandDeviceException };
